"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTemplateLayoutSchema = exports.BaseStyleSchema = exports.BaseInteractiveQuestionPinSettingsSchema = exports.BasePinSchema = exports.BasePinSettingsSchema = exports.DiffLabel = exports.DiffNoPickedLabels = exports.DiffCustomEntryLabels = exports.ExclusionTypeSchema = void 0;
const zod_1 = require("zod");
const pin_component_1 = require("../pin-component");
// TODO: Replaced student with homework and lesson with realtime, check if correct
// See: createFromLesson in AssignmentContent
// const pins = isTest ? AssignmentUtils.pinsExcluding(assignmentPins, 'homework') : assignmentPins;
exports.ExclusionTypeSchema = zod_1.z.enum(['realtime', 'homework']);
// TODO: Probably duplicated somewhere, should be uppercase but it's also used in old lesson as lowercase
exports.DiffCustomEntryLabels = zod_1.z.enum(['custom-1', 'custom-2', 'custom-3', 'custom-4', 'custom-5', 'custom-6']);
exports.DiffNoPickedLabels = zod_1.z.enum(['none-1', 'none-2', 'none-3', 'none-4', 'none-5', 'none-6']);
exports.DiffLabel = zod_1.z.enum(['-', '+', '0']).or(exports.DiffCustomEntryLabels).or(exports.DiffNoPickedLabels);
exports.BasePinSettingsSchema = zod_1.z.object({
    backgroundColor: zod_1.z.string().min(1).optional(),
    backgroundImage: zod_1.z.string().min(1).optional(),
    backgroundTransparency: zod_1.z.number().optional(),
    testPoints: zod_1.z.number().optional(), // TODO move to (quiz, openquestion, dragquestion) slide settings, resulted in a bunch of errors because we don't have good typeguarding inside our v1 to v2 mappers
    timer: zod_1.z.number().optional(), // TODO move to (quiz, openquestion, wordCloud) slide settings, resulted in a bunch of errors because we don't have good typeguarding inside our v1 to v2 mappers
    differentiation: exports.DiffLabel.optional(),
});
exports.BasePinSchema = zod_1.z.object({
    createdAt: zod_1.z.string(),
    id: zod_1.z.string().min(1),
    v1Pin: zod_1.z.string().min(1).optional(),
    order: zod_1.z.string(),
    pinComponents: zod_1.z.array(pin_component_1.PinComponentSchema),
    updatedAt: zod_1.z.string(),
    exclusions: zod_1.z.array(exports.ExclusionTypeSchema).optional(),
    parentPinId: zod_1.z.string().optional(), // if this is filled with a pin_id, the pin is a sub-pin on the interactive video question
    source: zod_1.z.string().optional(),
    settings: exports.BasePinSettingsSchema.merge(zod_1.z.object({
        layout: zod_1.z.string().min(1).optional(), // TODO: Code depends on all types to have a layout
    })),
    // // TODO ED-542  Commented until we are going to refactor the assignments backend / should be removed
    // item: z.object({
    // custom: z.any().optional(), // Differs per pin type. Everything in custom will move to settings.
    // components: z.any().optional(), // Component.All[], // renamed to pinComponents on the root, the types are / will be rewritten
    // url: z.string().optional(), // used by multiple pin types, should be moved to settings of specific pin types
    // uploadId: z.string().optional(), // we will remove this, wasn't filled consistently
    // exclusions: z.any().optional(), // was ExclusionType[]. 'realtime', 'homework'. can be moved to the pin root
    // shuffleMap: z.any().optional(), // quiz only, shuffling answers (assessment (test) only) -> teacherSettings
    // videoItems: z.any().optional(), // for interactive video Video.VideoItems[] , undefined, // video settings
    // notes: z.any().optional(), // Note, // teacherSettings for every pin (is there some base object or this?)
    // }),
    // videoQuestion: z.string().optional(), // if this is filled with a pin_id, the pin is a sub-pin on the interactive video question. Change to field name to parentPinId?
    // differentiation: z.any(), // same as diff. move to settings
});
exports.BaseInteractiveQuestionPinSettingsSchema = exports.BasePinSettingsSchema.merge(zod_1.z.object({
    questionId: zod_1.z.string().nullish(), // TODO: Should be required, nullish until data migration or make required and purge data
}));
exports.BaseStyleSchema = zod_1.z.object({
    fontFamily: zod_1.z.string().min(1).optional(),
    fontSize: zod_1.z.string().min(1).optional(),
});
exports.BaseTemplateLayoutSchema = zod_1.z.object({
    pinComponents: zod_1.z.array(pin_component_1.PinComponentSchema),
    backgroundColor: zod_1.z.string().optional(),
    backgroundImage: zod_1.z.string().optional(),
    backgroundTransparency: zod_1.z.number().optional(),
    layoutParts: zod_1.z.record(pin_component_1.LayoutPartSchema, pin_component_1.PinComponentSchema.optional()), // TODO: Can this be removed from the base without issues?
});
//# sourceMappingURL=base-pin.js.map